import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaHourglassEnd } from "react-icons/fa6";
import Overtimes from "./index";
import ViewOvertime from "./view";
import EditOvertime from "./edit";

import { MODULE_OVERTIME } from "variables/constants";

const overtimesRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Overtimes",
		basePath: "overtimes",
		mainComponent: <Overtimes />,
	    layout: "/console",	   
	    icon: <FaHourglassEnd className="icon-item" />,
	    subTitle:"Overtime",
	    viewComponent: <ViewOvertime />,
	    createComponent: <EditOvertime />,
	    editComponent: <EditOvertime />,
		level:5,
		moduleId: MODULE_OVERTIME,
	})
]

export default overtimesRoutes;